export interface IntervalPollerConfig {
  intervalMs: number;
  tick: () => Promise<void>;
  shouldContinue: () => boolean;
}

export class IntervalPoller {
  private handle: ReturnType<typeof setTimeout> | null = null;
  private active = false;
  private inFlight = false;

  constructor(private readonly config: IntervalPollerConfig) {}

  public update(): void {
    if (this.config.shouldContinue()) {
      this.start();
    } else {
      this.stop();
    }
  }

  public stop(): void {
    this.active = false;
    if (this.handle !== null) {
      clearTimeout(this.handle);
      this.handle = null;
    }
  }

  public runNow(): Promise<void> {
    return this.runTick();
  }

  private start(): void {
    if (this.active) {
      return;
    }
    this.active = true;
    this.scheduleNext();
  }

  private scheduleNext(): void {
    if (this.handle !== null) {
      return;
    }
    this.handle = setTimeout(async () => {
      this.handle = null;
      await this.runTick();
      if (this.active && this.config.shouldContinue()) {
        this.scheduleNext();
      } else {
        this.stop();
      }
    }, this.config.intervalMs);
  }

  private async runTick(): Promise<void> {
    if (this.inFlight) {
      return;
    }
    this.inFlight = true;
    try {
      await this.config.tick();
    } catch {
      // transient poll error; keep polling
    } finally {
      this.inFlight = false;
    }
  }
}
